import { useEffect, useMemo, useState } from 'react';

import { Box, Button, CircularProgress, Modal, TextField, Select, InputLabel,MenuItem, FormControl, FormHelperText, Grid, Paper } from '@mui/material';

import {createAddTransactionValidationSchema} from '../../../../../validations/PaymentTool/addNewTransactionValidation';

import { useCreateTransactionAdjustmentMutation, useEditTransactionAdjustmentMutation, useGetPeriodsQuery, useGetTransactionsQuery } from '../../../../../services/PaymentToolApi';

import { createErrorMessage } from '../../../../../utils/index';

import {useGetTransactionTypesQuery} from '../../../../../services/PaymentToolApi';

import { useNotification } from '../../../../../context/NotificationContext';
import { createErrorTransactionValidation } from '../../../../../validations/PaymentTool/createErrorTransactionValidation';
import isEqual from 'lodash/isEqual';
import {useRequestTypeQuery} from '../../../../../services/jobsApi';


const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
}

const NON_EDITABLE_TRANSACTION_TYPES = ['Penalty'];
const PRE_POPULATED_TRANSACTION_TYPES = ['Bonus', 'Penalty'];


const defaultEmptyValues={
  transactionTypeID: '',
  amount: '',
  relatedTransactionID: '',
  transactionReasonID: '',
  notesForBee: '',
  notesForAdmin: '',
  requestTypeID: '',
  linkedStnPurchaseID: ''
}

export default function AddTransactionModal({modalIsOpen, setModalIsOpen, selectedUser, period, defaultValues={}, defaultDisabledFields=[]}) {

  const { showNotification } = useNotification();
  
  const [formValues, setFormValues] = useState({ transactionTypeID: defaultValues.transactionTypeID || '', amount: '', relatedTransactionID: defaultValues.relatedTransactionID,transactionReasonID: '', notesForBee: '', notesForAdmin: '', requestTypeID: '', linkedStnPurchaseID: ''});
  const [formErrors, setFormErrors] = useState({});
  const [relatedTransactionError, setRelatedTransactionError] = useState(false);
  const { data: transactionTypes, isLoading: transactionTypesIsLoading, isError: transactionTypesIsError, error: transactionTypesError } = useGetTransactionTypesQuery();
  const [ createTransactionAdjustment, { data: transactionAdjustment, isLoading: transactionAdjustmentIsLoading, isError: transactionAdjustmentIsError, error: transactionAdjustmentError } ] = useCreateTransactionAdjustmentMutation();
  
  const {data: relatedTransactionInfo, isLoading: relatedTransactionInfoIsLoading, isFetching: relatedTransactionInfoIsFetching, isError: relatedTransactionInfoIsError, error: relatedTransactionInfoError} = useGetTransactionsQuery({transactionID: formValues.relatedTransactionID}, {skip: !formValues.relatedTransactionID || !modalIsOpen, refetchOnMountOrArgChange: true});
  
  const {data: periodsForCurrentYear, isLoading: periodsForCurrentYearIsLoading, isError: periodsForCurrentYearIsError, error: periodsForCurrentYearError} = useGetPeriodsQuery();

  const {data: requestTypes, isLoading: requestTypesIsLoading, isError: requestTypesIsError, error: requestTypesError} = useRequestTypeQuery();
  
  function getTransactionTypeName(transactionTypeID) {
    if(!transactionTypeID) return '';
    return transactionTypes.find(transactionType => transactionType.id === transactionTypeID).name;
  }
  
  function handleTransactionSave(formValues) {
    if(!period){
      console.log("Period is not defined using currentPeriod")
      //filter by startDate and endDate
      period= periodsForCurrentYear.find(period => new Date(period.startDate) <= new Date() && new Date(period.endDate) >= new Date());
      console.log("currentPeriod: " , period)
    }
    let newTransaction={
      "transactionTypeID": formValues.transactionTypeID,
      "amount": formValues.amount,
      "relatedTransactionID": formValues.relatedTransactionID,
      "notesForBee": formValues.notesForBee,
      "notesForAdmin": formValues.notesForAdmin,
      "transactionReasonID": formValues.transactionReasonID,
      "userID": selectedUser.id,
      //A: if period is not completed, the transaction must be saved with the period the user is in
      "periodID": period.isCompleted == false ? period.id : null,
      "requestTypeID": formValues.requestTypeID,
      "linkedStnPurchaseID": formValues.linkedStnPurchaseID
    }
    console.log(newTransaction)
    createTransactionAdjustment(newTransaction).unwrap()
      .then((res) => {
        console.log(res);
        setModalIsOpen(false);
        showNotification(' Transaction saved successfully', 'success');
        setFormValues({ amount: '',transactionTypeID: '', relatedTransactionID: '', notesForBee: '', notesForAdmin: '', transactionReasonID: '', requestTypeID: '', linkedStnPurchaseID: ''});
      })
      .catch((err) => {
        console.log(err);
        showNotification(createErrorMessage(err), 'error');
      });
  }

  const handleCloseTransaction = () => {
    setFormValues({ amount: '', transactionTypeID: '', relatedTransactionID: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', requestTypeID: '', linkedStnPurchaseID: ''});
    setFormErrors({ amount: '',transactionTypeID: '', relatedTransactionID: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', requestTypeID: '', linkedStnPurchaseID: ''});
    setRelatedTransactionError(null);
    setModalIsOpen(false);
  };

  const NonPenaltyValidationSchema = useMemo(() => createAddTransactionValidationSchema(transactionTypes), [transactionTypes]);
  const PenaltyValidationSchema = useMemo(() => createErrorTransactionValidation(), []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Clear previous errors
    setFormErrors({ amount: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', relatedTransactionID: ''});
  
    // Retrieve the name of the transaction type based on the form value
    const transactionTypeName = transactionTypes.find(transactionType => transactionType.id === formValues.transactionTypeID)?.name;
    console.log(transactionTypeName);
  
    // Determine the validation schema based on the transaction type
    const chosenSchema = transactionTypeName === "Penalty" ? PenaltyValidationSchema : NonPenaltyValidationSchema;
    
    console.log("formValues: ", formValues);
    try {
      // Validate form values against the chosen schema
      await chosenSchema.validate(formValues, { abortEarly: false });
      // If validation is successful, proceed to save the transaction
      handleTransactionSave(formValues);
    } catch (err) {
      // Handle validation errors
      console.log(err);
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      setFormErrors(errors);
    }
  };

  function isNonEditableTransactionType(transactionTypeID) {
    if(!transactionTypeID) return false;
    //A: if relatedTransactionId is empty, the amount is editable
    if(!formValues.relatedTransactionID) return false;
    return NON_EDITABLE_TRANSACTION_TYPES.includes(transactionTypes.find(transactionType => transactionType.id === transactionTypeID).name);
  }

  function handleRelatedTransactionChange(event) {
    const { name, value:newRelatedTransactionID  } = event.target;

    //A: if relatedTransactionId is empty, clean amount and relatedTransactionError
    if(!newRelatedTransactionID){
      setFormValues(prevState => ({
        ...prevState,
        [name]: newRelatedTransactionID,
        amount: '',
      }));
      setRelatedTransactionError(null);
      return;
    }
    

    if(!formValues.transactionTypeID) return handleChange(event);
    if(PRE_POPULATED_TRANSACTION_TYPES.includes( getTransactionTypeName( formValues.transactionTypeID ))){
      setFormValues(prevState => ({
        ...prevState,
        [name]: newRelatedTransactionID,
        amount: relatedTransactionInfo ? relatedTransactionInfo[0]?.amount : formValues.amount
      }));
    }else{
      handleChange(event);
    }
    
  }

  function handleTransactionTypeChange(event) {
    const { name, value:newTransactionTypeID  } = event.target;
    if(!formValues.relatedTransactionID) return handleChange(event);
    if(PRE_POPULATED_TRANSACTION_TYPES.includes( getTransactionTypeName( newTransactionTypeID ))){
      setFormValues(prevState => ({
        ...prevState,
        [name]: newTransactionTypeID,
        amount: relatedTransactionInfo ? relatedTransactionInfo[0]?.amount : formValues.amount
      }));
    }else{
      handleChange(event);
    }
  }

  useEffect(() => {
    if(relatedTransactionInfoIsError){
      setRelatedTransactionError(createErrorMessage(relatedTransactionInfoError));
    }
  }, [relatedTransactionInfoIsError]);

  useEffect(() => {
    if (!isEqual(formValues, defaultValues) && Object.keys(defaultValues).length > 0) {
      console.log("applying default values : ", defaultValues);
      let auxFormValues = {...defaultEmptyValues, ...defaultValues};
      setFormValues(auxFormValues);
    }
  }, [defaultValues]);

  useEffect(() => {
    if(!formValues.transactionTypeID) return;
    if(!formValues. relatedTransactionID) return;
    if(PRE_POPULATED_TRANSACTION_TYPES.includes( getTransactionTypeName( formValues.transactionTypeID ))){
      setFormValues(prevState => ({
        ...prevState,
        amount: relatedTransactionInfo ? relatedTransactionInfo[0]?.amount : formValues.amount
      }));
    }
  }, [relatedTransactionInfo, formValues.transactionTypeID]);


  useEffect(() => {
    if(!relatedTransactionInfo || !transactionTypes) return;
    if (relatedTransactionInfo.length === 0) {
      setRelatedTransactionError('Related Transaction not found');
    } else if (relatedTransactionInfo.length === 1) {
      if (getTransactionTypeName(relatedTransactionInfo[0].transactionTypeID) !== 'Reward') {
        setRelatedTransactionError('Related Transaction is not a Reward transaction');
      } else {
        setRelatedTransactionError(null);
      }
    }else{
      setRelatedTransactionError(null)
    }
    
  }, [relatedTransactionInfo, transactionTypes]);

  if(transactionTypesIsLoading || requestTypesIsLoading) return <div>Loading...</div>;

  // function to update formValues in a general way
  const updateFormValues = (name, value) => {
    setFormValues(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  function handleTransactionTypeChange(event){
    let typeBefore= transactionTypes.find(transactionType => transactionType.id === formValues.transactionTypeID)?.name;
    let typeAfter= transactionTypes.find(transactionType => transactionType.id === event.target.value)?.name;
    console.log("typeBefore: ", typeBefore);
    console.log("typeAfter: ", typeAfter);
    if (typeBefore === "Reward" && typeAfter !== "Reward") {
      // specific case when we change from "Reward" to another value
      setFormValues(prevState => ({
        ...prevState,
        requestTypeID: "",
        linkedStnPurchaseID: "",
        "transactionTypeID": event.target.value
      }));
    }
    else {
      // general case of update for transactionTypeID
      updateFormValues("transactionTypeID", event.target.value);
    }
  }

  const handleChange = (event) => {
    const { name, value } = event.target;

    if(name === "transactionTypeID"){
      console.log("case: transactionTypeID");
      handleTransactionTypeChange(event);
    }
    else {
      console.log("case: else");

      updateFormValues(name, value);
    }
  };

  return (
    <>
      <Modal
        open={modalIsOpen}
        onClose={handleCloseTransaction}
      >
        <Box sx={ModalStyle}>

          <form noValidate onSubmit={handleSubmit}>
            <p style={{ color: 'var(--orange)', margin: '0 0 0.5em 0' }}>Add Transaction</p>
            <Grid container spacing={2}>

              {/* SELECT TRANSACTION TYPE */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth error={!!formErrors.transactionTypeID}>
                  <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Transaction Type</p>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formValues.transactionTypeID}
                    name="transactionTypeID" 
                    onChange={handleChange}
                    sx={{ height: '41px',  margin: '0 0 0.5em 0' }}
                    disabled={defaultDisabledFields.includes('transactionTypeID')}
                  >
                    {transactionTypes.filter(t => t.name != "Penalty").map((transactionType) => (
                      <MenuItem key={transactionType.id} value={transactionType.id}>{transactionType.name }</MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>{formErrors.transactionTypeID}</FormHelperText>
                </FormControl>  
              </Grid>
              
              {/* SELECT RequestType (BuyType for user) */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth error={!!formErrors.requestTypeID}>
                  <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Buy Type</p> {/* for user request type is job type */}
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formValues.requestTypeID}
                    name="requestTypeID" 
                    onChange={handleChange}
                    sx={{ height: '41px',  margin: '0 0 0.5em 0' }}
                    disabled={formValues.transactionTypeID === "" || transactionTypes.find(transactionType => transactionType.id === formValues.transactionTypeID).name !== "Reward"}
                  >
                    {requestTypes.map((requestType) => (
                      //A: the replace function split the string in two when a lowercase letter is followed by an uppercase letter
                      <MenuItem key={requestType.id} value={requestType.id}>{requestType.name.replace(/([a-z])([A-Z])/g, '$1 $2') }</MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>{formErrors.requestTypeID}</FormHelperText>
                </FormControl>  
              </Grid>

              {/* Enter Linked StN PurchaseID*/}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Linked StN PurchaseID</p>
                <TextField
                  name="linkedStnPurchaseID"
                  disabled={getTransactionTypeName(formValues.transactionTypeID) !== "Reward" || defaultDisabledFields.includes('linkedStnPurchaseID') }
                  value={formValues.linkedStnPurchaseID}
                  onChange={handleChange}
                  error={!!formErrors.linkedStnPurchaseID}
                  helperText={formErrors.linkedStnPurchaseID}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                />
              </Grid>

              {/* SELECT Related Transaction */}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Related Transaction</p>
                <TextField
                  disabled={defaultDisabledFields.includes('relatedTransactionID')}
                  name="relatedTransactionID"
                  required
                  value={formValues.relatedTransactionID}
                  onChange={handleRelatedTransactionChange}
                  error={!!formErrors.relatedTransactionID || relatedTransactionError}
                  helperText={formErrors.relatedTransactionID || relatedTransactionError || (relatedTransactionInfoIsLoading || relatedTransactionInfoIsFetching && "Loading...")}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                />
              </Grid>

              {/* Enter Amount */}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Amount</p>
                <TextField 
                  name="amount"
                  required
                  value={formValues.amount}
                  disabled={isNonEditableTransactionType(formValues.transactionTypeID)}
                  onChange={handleChange}
                  error={!!formErrors.amount}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                  helperText={formErrors.amount}
                />
              </Grid>
            </Grid>

            

            {/* WRITE BEE COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Reason Details (Visible for Bee)</p>
            <TextField
              multiline
              rows={4}
              name="notesForBee"
              value={formValues.notesForBee}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForBee}
              helperText={formErrors.notesForBee}
            />

            {/* WRITE ADMIN COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Internal Notes (Visible only for Admins)</p>
            <TextField
              multiline
              rows={4}
              name="notesForAdmin"
              value={formValues.notesForAdmin}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForAdmin}
              helperText={formErrors.notesForAdmin}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant='contained' color='secondary' sx={{ minWidth: '100px', margin:'0 1em 0 0' }} name="cancelButton" onClick={handleCloseTransaction}>Cancel</Button>
              <Button variant='contained' type="submit" name="acceptButton" color='primary' sx={{ minWidth: '100px' }} disabled={transactionAdjustmentIsLoading || relatedTransactionError || relatedTransactionInfoIsLoading || relatedTransactionInfoIsFetching} >{ transactionAdjustmentIsLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Ok" }</Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
}